import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { StrategiesOption } from 'sections/Resources/DemurrageAndDetention/types';
import { strategiesOptions } from 'sections/Resources/DemurrageAndDetention/data';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionStrategies/SectionStrategies.module.scss';

const cn = classNames.bind(styles);

const SectionStrategies = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  const renderHeadingContentByScreenWidth = () => {
    if (screenWidth >= 769) {
      return (
        <>
          <span>Navigating Demurrage and Detention:</span>{' '}
          <span>Strategies for Freight Forwarders</span>
        </>
      );
    } else {
      return (
        <>
          <span>Navigating Demurrage and</span>{' '}
          <span>Detention: Strategies for</span>{' '}
          <span>Freight Forwarders</span>
        </>
      );
    }
  };

  const listOptions = strategiesOptions.map((option: StrategiesOption) => {
    return (
      <li className={cn('strategies__list-item')} key={option.id}>
        <h4 className={cn('strategies__list-item-heading')}>
          {option.heading}
        </h4>
        <p className={cn('strategies__list-item-description')}>
          {option.description}
        </p>
      </li>
    );
  });

  return (
    <section className={cn('strategies')}>
      <div className={cn('container')}>

        <div className={cn('strategies__heading-container')}>
          <h2 className={cn('strategies__heading')}>
            {renderHeadingContentByScreenWidth()}
          </h2>
          <p className={cn('strategies__heading-description')}>
            Reducing and sometimes even completely eliminating these fees boils down
            to strategic planning and proactive measures to prevent delays.
          </p>
        </div>

        <ol className={cn('strategies__list')}>
          {listOptions}
        </ol>

      </div>
    </section>
  );
};

export default SectionStrategies;